import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80">
    <title>Loader Logo</title>
    <g>
      <g id="B" transform="translate(11.000000, 5.000000)">
        <path
          d="M42.7,19.4v5.1c-5.4,0.1-6.9,1.9-6.9,3.7c0,3.2,0.6,4.7,0.6,8.3c0,5.6-2.9,7.5-9.5,7.5h-4.2v-4.6h1.9
          c3.8,0,4.7-0.5,4.7-3.2c0-2.6-0.2-5-0.2-8c0-4.1,1.6-5.5,5.3-6.1v-0.2c-3.7-0.6-5.3-2-5.3-6.1c0-3,0.2-5.4,0.2-8
          c0-2.6-0.9-3.2-4.7-3.2h-1.9V3.8c0-0.5,0-1,0-1.5c-2.4,0.4-4.7,0.8-7.1,1.2v1.1H6.6v34.7h8.9v4.6H0V0h15.5v2.6c0,0.3,0,0.6,0,0.9
          c2.4-0.4,4.7-0.8,7.1-1.2V0h4.2c6.6,0,9.5,1.8,9.5,7.5c0,3.6-0.6,5.1-0.6,8.2C35.8,17.5,37.3,19.3,42.7,19.4z"
          fill="currentColor"
        />
      </g>
      
    </g>
  </svg>
);

export default IconLoader;
